import React from 'react';
import { motion } from 'framer-motion';
const row1 = [{
  src: 'https://cdn.magicpatterns.com/uploads/oNkXXuUCAJqEnroTzx6y8Q/axelc.jpg',
  alt: 'Textured crop fade'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5Cfhq9o63zMLPkeTsrFQeN/axel_c11.jpg',
  alt: 'Curly top fade'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hqVDYLC8wzsKaCDmt82NnH/axel_16.jpg',
  alt: 'Layered cut with bangs'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oS63yoMeMed2kvVqs21K1H/axel_c_10.jpg',
  alt: 'Precision scissors work'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4p3aZF2PuG2xskQk9wpHRJ/axel_c_6.jpg',
  alt: 'Clean buzz fade'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uSLVUdg7cnCGEkMJWNMTHf/axel_c4.jpg',
  alt: 'Sharp fade profile'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oZsb2ybRJ6pTEAwDWhoY84/axel_c7.jpg',
  alt: 'Classic side part'
}];
const row2 = [{
  src: 'https://cdn.magicpatterns.com/uploads/2dcY6Yt9DUUhq5RU7g6oKp/axel_c9.jpg',
  alt: 'Clean waves fade'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bw73YfFwmNV4s84H2hvejF/axel_15.jpg',
  alt: 'Wavy dark layers'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7ez3JsudzMX8CFCuWBEReK/axel_c_12.jpg',
  alt: "Kid's clean fade"
}, {
  src: 'https://cdn.magicpatterns.com/uploads/xwp6Ucxd2qWBtVmoEXFJKX/axelc8.jpg',
  alt: 'Curly top natural'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2TneFZ6yEzcvHK7dUiQXwP/axel_ot5.jpg',
  alt: 'Textured quiff with fade'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ksiBEVQ7D6Sqtc24X4W9cJ/axel_14.jpg',
  alt: 'Sleek asymmetric bob'
}];
function CarouselRow({
  images,
  direction = 'left',
  speed = 35
}: {
  images: typeof row1;
  direction?: 'left' | 'right';
  speed?: number;
}) {
  const doubled = [...images, ...images];
  return <div className="relative overflow-hidden group/row" data-id="element-49">
      {/* Edge fades */}
      <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-matte to-transparent z-10 pointer-events-none" data-id="element-50" />
      <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-matte to-transparent z-10 pointer-events-none" data-id="element-51" />

      <div className="flex gap-4 group-hover/row:[animation-play-state:paused]" style={{
      animation: `scroll-${direction} ${speed}s linear infinite`,
      width: 'max-content'
    }} data-id="element-52">
        {doubled.map((image, index) => <div key={index} className="relative flex-shrink-0 w-[260px] h-[320px] md:w-[300px] md:h-[380px] rounded-xl overflow-hidden group/card cursor-pointer" data-id="element-53">
            <img src={image.src} alt={image.alt} className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover/card:scale-110" data-id="element-54" />
            <div className="absolute inset-0 bg-black/10 group-hover/card:bg-black/0 transition-colors duration-500" data-id="element-55" />
            <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover/card:border-gold/60 transition-colors duration-500" data-id="element-56" />
            <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover/card:opacity-100 transition-opacity duration-500" data-id="element-57" />
          </div>)}
      </div>
    </div>;
}
export function GallerySection() {
  return <section className="py-24 bg-matte relative overflow-hidden" data-id="element-58">
      <style data-id="element-59">{`
        @keyframes scroll-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes scroll-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>

      {/* Subtle ambient glow */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-60" />

      <div className="relative z-10" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14 px-4" data-id="element-62">
          <h2 className="font-display text-3xl md:text-5xl text-gold mb-4 italic" data-id="element-63">
            Our Work Speaks for Itself
          </h2>
          <p className="font-body text-cream/60 font-light text-lg max-w-xl mx-auto" data-id="element-64">
            Real results. Real transformations. Every client leaves looking
            their absolute best.
          </p>
          <div className="h-[1px] w-24 bg-gold/30 mx-auto mt-6" data-id="element-65" />
        </motion.div>

        <div className="space-y-4" data-id="element-66">
          <CarouselRow images={row1} direction="left" speed={40} data-id="element-67" />
          <CarouselRow images={row2} direction="right" speed={45} data-id="element-68" />
        </div>
      </div>
    </section>;
}